import React, { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";
import "../../../../styles/stores/makeTransactions/confirmProducts.css";

/* 80mm thermal */
const Receipt = () => {
  const barcodeRef = useRef(null);

  const transaction = {
    transID: "TXN123456789",
    date: "2025-04-04T10:00:00Z",
    totalAmount: 25000,
    deliveryStatus: "SUPPLIED",
    paymentMode: "Cash",
    products: [{ name: "Milk", quantity: 1, price: 25000 }],
  };

  const customer = {
    name: "Ebuka Malachi Eya",
    email: "eyauka@gmail.com",
    phone: "+45945447264",
    address: "Emma gads vej 12",
  };

  useEffect(() => {
    if (transaction?.transID && barcodeRef.current) {
      JsBarcode(barcodeRef.current, transaction.transID.toString(), {
        format: "CODE128",
        width: 2,
        height: 40,
        displayValue: false,
      });
    }
  }, [transaction]);

  useEffect(() => {
    // Auto-print on mount
    // window.print();
  }, []);

  return (
    <div
      style={{
        width: "80mm",
        padding: "14px",
        fontFamily: "monospace",
        background: "#fff",
        color: "#000",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "6px", fontSize: "16px" }}>🛍️ Urban Mart</h2>
      <p style={{ textAlign: "center", fontSize: "10px", marginBottom: "8px" }}>Receipt No: #{transaction.transID}</p>

      <p style={{ fontSize: "11px" }}>
        <strong>Date:</strong> {new Date(transaction.date).toLocaleString()}
      </p>

      <hr style={{ borderTop: "1px dashed #000" }} />

      <p style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>👤 Customer Info</p>
      <p style={{ margin: 0 }}>Name: {customer.name}</p>
      <p style={{ margin: 0 }}>Email: {customer.email}</p>
      <p style={{ margin: 0 }}>Phone: {customer.phone}</p>
      <p style={{ marginBottom: "6px" }}>Address: {customer.address}</p>

      <hr style={{ borderTop: "1px dashed #000" }} />

      <p style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>📦 Transaction Details</p>
      <p style={{ margin: 0 }}>Delivery Status: {transaction.deliveryStatus}</p>
      <p style={{ margin: 0 }}>Number of Items: {transaction.products.reduce((acc, item) => acc + item.quantity, 0)}</p>
      <p style={{ margin: 0 }}>Total Price: ₦{transaction.totalAmount.toLocaleString()}</p>
      <p style={{ marginBottom: "6px" }}>Payment Mode: {transaction.paymentMode}</p>

      <hr style={{ borderTop: "1px dashed #000" }} />

      <table style={{ width: "100%", fontSize: "11px", marginBottom: "6px" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left" }}>Item</th>
            <th style={{ textAlign: "right" }}>Qty</th>
            <th style={{ textAlign: "right" }}>Price</th>
          </tr>
        </thead>
        <tbody>
          {transaction.products.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td style={{ textAlign: "right" }}>{item.quantity}</td>
              <td style={{ textAlign: "right" }}>₦{item.price.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ textAlign: "right", fontWeight: "bold", fontSize: "12px", marginBottom: "8px" }}>Total: ₦{transaction.totalAmount.toLocaleString()}</p>

      <div style={{ textAlign: "center", marginBottom: "8px" }}>
        <svg ref={barcodeRef}></svg>
      </div>

      <p style={{ textAlign: "center", fontSize: "10px", fontStyle: "italic" }}>Thank you for shopping with us 💙</p>
    </div>
  );
};

export default Receipt;

export const ThermalPrinterDemo = () => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printerStatus, setPrinterStatus] = useState("");

  // ESC/POS commands for thermal printer
  const getReceiptData = () => {
    const encoder = new TextEncoder();
    return encoder.encode(
      "\x1B@\x1B\x61\x01🛍️ Urban Mart\x0A" + // Initialize + center align
        "\x1B\x61\x00\x1B\x45\x01RECEIPT #TXN123\x0A" + // Bold
        "\x1B\x45\x00----------------\x0A" + // Normal text
        "Customer: Ebuka Eya\x0A" +
        "Item: Milk x1\x0A" +
        "Total: ₦25,000\x0A" +
        "\x1B\x61\x02THANK YOU!\x0A" + // Right align
        "\x1D\x56\x41\x03" // Cut paper (full cut)
    );
  };

  useEffect(() => {
    console.log("WebUSB support: ", navigator.usb);
  }, []);

  const printReceipt = async () => {
    setIsPrinting(true);
    setPrinterStatus("Connecting...");

    try {
      // Step 1: Request USB device access
      const device = await navigator.usb.requestDevice({
        filters: [{ vendorId: 0x0416 }], // Epson vendor ID (adjust for your printer)
      });
      // Close any existing connection first
      if (device.opened) {
        console.log("Closing existing device connection...");

        await device.close();
      }
      // Add delay for device reset
      await new Promise((resolve) => setTimeout(resolve, 500));

      await device.open();
      await device.selectConfiguration(1);
      await device.reset(); // Critical reset command
      await device.claimInterface(0);

      setPrinterStatus("Initializing printer...");
      await device.open();
      await device.selectConfiguration(1);
      await device.claimInterface(0);

      // Step 2: Send ESC/POS commands
      setPrinterStatus("Printing...");
      await device.transferOut(1, getReceiptData());

      setPrinterStatus("Printed successfully!");
    } catch (error) {
      setPrinterStatus(`Error: ${error.message}`);
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h1>Thermal Printer WebUSB Demo</h1>
      <button
        onClick={printReceipt}
        disabled={isPrinting}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: isPrinting ? "#ccc" : "#0066cc",
          color: "white",
          border: "none",
          borderRadius: "4px",
        }}
      >
        {isPrinting ? "Printing..." : "Print Receipt"}
      </button>

      <div style={{ marginTop: "20px", color: "#666" }}>
        {printerStatus && <p>Status: {printerStatus}</p>}
        {!navigator.usb && (
          <p style={{ color: "red" }}>WebUSB not supported. Use Chrome/Edge and enable: chrome://flags/#enable-experimental-web-platform-features</p>
        )}
      </div>

      {/* Preview (simulated receipt) */}
      <div
        style={{
          marginTop: "40px",
          width: "80mm",
          border: "1px dashed #999",
          padding: "10px",
          fontFamily: "monospace",
        }}
      >
        <p style={{ textAlign: "center" }}>🛍️ Urban Mart</p>
        <p>
          <b>RECEIPT #TXN123</b>
        </p>
        <hr />
        <p>Customer: Ebuka Eya</p>
        <p>Item: Milk x1</p>
        <p>Total: ₦25,000</p>
        <p style={{ textAlign: "right" }}>THANK YOU!</p>
      </div>
    </div>
  );
};

export const ThermalReceipt = ({ transaction }) => {
  const receiptRef = useRef();

  const handlePrint = () => {
    const printContent = receiptRef.current.innerHTML;
    const WindowPrt = window.open("", "", "width=300,height=600");
    WindowPrt.document.write(`
      <html>
        <head>
          <style>
            @media print {
              body {
                width: 80mm;
                margin: 0;
                font-family: 'Courier New', Courier, monospace;
                font-size: 12px;
              }
              .receipt {
                width: 80mm;
                padding: 5px;
              }
              .receipt h2, .receipt h4 {
                text-align: center;
                margin: 0;
                padding: 5px 0;
              }
              .receipt p {
                margin: 3px 0;
              }
              .divider {
                border-top: 1px dashed #000;
                margin: 10px 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt">${printContent}</div>
          <script>window.onload = function() { window.print(); window.close(); }</script>
        </body>
      </html>
    `);
    WindowPrt.document.close();
  };

  return (
    <div>
      <div ref={receiptRef} style={{ display: "none" }}>
        <h2>🏪 Urban Mart</h2>
        <h4>Receipt</h4>
        <div className='divider' />
        <p>Transaction ID: "ff"</p>
        <p>Date: </p>
        <div className='divider' />

        <div className='divider' />
        <p>
          <strong>Total: ₦</strong>
        </p>
        <p>Payment: </p>
        <div className='divider' />
        <p>Thank you for shopping!</p>
      </div>

      <button onClick={handlePrint}>🖨️ Print Receipt</button>
    </div>
  );
};
